<template>
  <template v-if="!isLoading && recipients">
    <div class="default-recipient" v-if="recipients && recipients.length > 0">
      <div class="row">
        <div class="col-lg-6 mb-3">
          <label for="language" class="form-label">{{ $t('DefaultRecipient') }}</label>
          <select class="form-select" v-model="defaultRecipient" :disabled="isAppendAnotherRecipient">
            <option disabled selected value="">{{ $t('SelectDefaultRecipient') }}</option>
            <option :value="recipient.id" v-for="recipient in recipients" :key="recipient.id">
              {{ recipient.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="mt-3"></div>
    </div>
    <div class="recipient" id="recipient-{{ recipient.id }}" :class="index === recipients.length - 1 ? 'recipientLast' : ''" v-for="(recipient, index) in recipients" :key="recipient.id">
      <div class="row">
        <div class="col-lg-6 mb-3">
          <label for="name" class="form-label">{{ $t('NameProfile') }}</label>
          <input type="text"
                 v-model="recipient.name"
                 name="name"
                 class="form-control input-dirty"
                 placeholder=""
                 aria-describedby="name"
                 autocomplete="key-name-{{ recipient.id }}"
                 :disabled="isAppendAnotherRecipient"
          >
        </div>
        <div class="col-lg-6 mb-3">
          <div class="recipient__remove">
            <div v-if="!isAppendAnotherRecipient" class="recipient__remove__icon" data-recipient="{{ recipient.id }}"
                 @click="this.removeRecipient(recipient.id)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                   class="bi bi-trash3" viewBox="0 0 16 16">
                <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5
                0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2
                2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0
                0 0-.01 0zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487
                1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5
                0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0
                0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 mb-3">
          <label for="first_name" class="form-label">{{ $t('FirstName') }}</label>
          <input type="text"
                 v-model="recipient.first_name"
                 name="first_name"
                 class="form-control input-dirty"
                 placeholder=""
                 aria-describedby="first_name"
                 autocomplete="key-first-name-{{ recipient.id }}"
                 :disabled="isAppendAnotherRecipient"
          >
        </div>
        <div class="col-lg-4 mb-3">
          <label for="last_name" class="form-label">{{ $t('LastName') }}</label>
          <input type="text"
                 v-model="recipient.last_name"
                 name="last_name"
                 class="form-control input-dirty"
                 placeholder=""
                 aria-describedby="last_name"
                 autocomplete="key-last-name-{{ recipient.id }}"
                 :disabled="isAppendAnotherRecipient"
          >
        </div>
        <div class="col-lg-4 mb-3">
          <label for="surname" class="form-label">{{ $t('Surname') }}</label>
          <input type="text"
                 v-model="recipient.surname"
                 name="surname"
                 class="form-control input-dirty"
                 placeholder=""
                 aria-describedby="surname"
                 autocomplete="key-surname-{{ recipient.id }}"
                 :disabled="isAppendAnotherRecipient"
          >
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 mb-3">
          <label for="phoneRecipient" class="form-label">{{ $t('Phone') }}</label>
          <dashboard-field-phone v-model="recipient.phone"
                                 :set_phone="recipient.phone"
                                 :disabled="isAppendAnotherRecipient"/>
        </div>
      </div>
    </div>
    <div class="recipient recipientLast" v-if="isAppendAnotherRecipient">
      <div class="row">
        <div class="col-lg-6 mb-3">
          <label for="name" class="form-label">{{ $t('NameProfile') }}</label>
          <input type="text"
                 v-model="anotherRecipient.name"
                 name="name"
                 class="form-control input-dirty"
                 placeholder=""
                 aria-describedby="name"
                 autocomplete="key-name-append-recipient"
          >
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 mb-3">
          <label for="first_name" class="form-label">{{ $t('FirstName') }}</label>
          <input type="text"
                 v-model="anotherRecipient.first_name"
                 name="first_name"
                 class="form-control input-dirty"
                 placeholder=""
                 aria-describedby="first_name"
                 autocomplete="key-first-name-append-recipient"
          >
        </div>
        <div class="col-lg-4 mb-3">
          <label for="last_name" class="form-label">{{ $t('LastName') }}</label>
          <input type="text"
                 v-model="anotherRecipient.last_name"
                 name="last_name"
                 class="form-control input-dirty"
                 placeholder=""
                 aria-describedby="last_name"
                 autocomplete="key-last-name-append-recipient"
          >
        </div>
        <div class="col-lg-4 mb-3">
          <label for="surname" class="form-label">{{ $t('Surname') }}</label>
          <input type="text"
                 v-model="anotherRecipient.surname"
                 name="surname"
                 class="form-control input-dirty"
                 placeholder=""
                 aria-describedby="surname"
                 autocomplete="key-surname-append-recipient"
          >
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 mb-3">
          <label for="phone" class="form-label">{{ $t('Phone') }}</label>
          <dashboard-field-phone v-model="anotherRecipient.phone" />
        </div>
      </div>
    </div>
    <div class="mt-4">
      <div class="recipient__addAnotherRecipient" v-if="allowedAppendAnotherRecipient && !isAppendAnotherRecipient"
           @click="showAppendAnotherRecipient">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
             class="bi bi-plus-lg" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1
          0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
        </svg>
        <div class="recipient__addAnotherRecipient__label">
          {{ $t('AddAnotherRecipient') }}
        </div>
      </div>
    </div>
    <div class="mt-4" v-if="isAppendAnotherRecipient">
      <button class="btn btn-success" @click="createRecipient" :disabled="isLoading">
        {{ $t('AddRecipient') }}</button>
      <button type="button" @click="cancelAppendAnotherRecipient"
              class="btn btn-secondary">{{ $t('Cancel') }}</button>
    </div>
    <div class="mt-4" v-if="!isAppendAnotherRecipient">
      <button class="btn btn-success" :disabled="isLoading" @click="updateRecipients">
        {{ $t('Save') }}
      </button>
      <button type="button"
              class="btn btn-secondary" @click="restoreUpdateRecipients">
        {{ $t('Cancel') }}
      </button>
    </div>
  </template>
  <template v-else>
    <dashboard-local-preloader/>
  </template>
</template>

<script>
import DashboardLocalPreloader from "@/components/LocalPreloader.vue"
import DashboardFieldPhone from "@/components/fields/phone.vue"

import {mapGetters} from "vuex";
import {actionTypes, mutationTypes, getterTypes} from "@/store/modules/recipients";

export default {
  name: 'DashboardRecipients',
  components: {
    DashboardLocalPreloader,
    DashboardFieldPhone
  },
  mounted() {
    this.$store.commit(mutationTypes.clearRecipients)
    this.$store.dispatch(actionTypes.getRecipients).then(() => {
      this.getDefaultRecipient()
    })
  },
  data(){
    return {
      logoTrash: require('@/assets/svg/trash3.svg'),
      isAppendAnotherRecipient: false,
      defaultRecipient: null,
      anotherRecipient: {
        name: '',
        first_name: '',
        last_name: '',
        surname: '',
        phone: '',
      },
      maxRecipients: 5
    }
  },
  methods: {
    Notification(type, title, text){
      this.$notify({
        group: 'main',
        title: title,
        text: text,
        type: type,
        duration: 7000
      });
    },
    removeRecipient(recipient_id){
      this.$store.dispatch(actionTypes.removeRecipient, {id: recipient_id}).then(response => {
        if (response.status === 200){
          this.Notification(
              'success',
              this.$t('Successfully'),
              this.$t('ThisRecipientHasBeenDeleted')
          )
        }
      }).then(() => {
        this.restoreUpdateRecipients()
      })
    },
    showAppendAnotherRecipient(){
      if (this.allowedAppendAnotherRecipient){
        this.isAppendAnotherRecipient = true
      } else {
        this.isAppendAnotherRecipient = false
      }
    },
    cancelAppendAnotherRecipient(){
      this.isAppendAnotherRecipient = false
      this.clearAnotherRecipient()
    },
    clearAnotherRecipient(){
      this.anotherRecipient.name = ''
      this.anotherRecipient.first_name = ''
      this.anotherRecipient.last_name = ''
      this.anotherRecipient.surname = ''
      this.anotherRecipient.phone = ''
    },
    restoreUpdateRecipients(){
      this.cancelAppendAnotherRecipient()
      this.$store.commit(mutationTypes.clearRecipients)
      this.$store.dispatch(actionTypes.getRecipients).then(() => {
        this.getDefaultRecipient()
      })
    },
    createRecipient(){
      this.$store.dispatch(actionTypes.createRecipient, {
        name: this.anotherRecipient.name,
        first_name: this.anotherRecipient.first_name,
        last_name: this.anotherRecipient.last_name,
        surname: this.anotherRecipient.surname,
        phone: this.anotherRecipient.phone,
        is_default: false
      }).then(response => {
        if (response.status === 200){
          this.Notification(
              'success',
              this.$t('Successfully'),
              this.$t('ANewRecipientHasBeenAdded')
          )
          this.restoreUpdateRecipients()
        } else {
           this.Notification(
              'error',
              this.$t('Error'),
              this.$t('fillInTheAppropriateFields')
          )
        }
      })
    },
    updateRecipients(){
      this.recipients.forEach((recipient) => {
        let isDefault = false
        if (this.defaultRecipient === recipient.id){
          isDefault = true
        }
        this.$store.dispatch(actionTypes.updateRecipient, {
          id: recipient.id,
          name: recipient.name,
          first_name: recipient.first_name,
          last_name: recipient.last_name,
          surname: recipient.surname,
          phone: recipient.phone,
          is_default: isDefault
        })
      })
      this.restoreUpdateRecipients()
      this.Notification(
            'success',
            this.$t('Successfully'),
            this.$t('RecipientInformationHasBeenUpdated')
        )
    },
    getDefaultRecipient(){
      if (this.recipients !== null) {
        this.recipients.forEach((recipient) => {
          if (recipient.is_default === true) {
            this.defaultRecipient = recipient.id
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      recipients: getterTypes.recipients,
      isLoading: getterTypes.isLoading,
      isMore: getterTypes.isMore,
    }),
    allowedAppendAnotherRecipient(){
      if (this.recipients !== null){
        return this.recipients.length - this.maxRecipients < 5
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";
  @import "@/scss/mixins.scss";

  .recipient{
    padding-bottom: 35px;
    margin-bottom: 40px;
    border-bottom: 1px solid #e9e9e9;
    .fieldRequired{
      font-size: 10px;
    }
    &__remove{
      display: flex;
      justify-content: right;
      &__icon{
        padding: 0 10px 0 10px;
        cursor: pointer;
        &:hover{
          color: $danger;
        }
      }
    }
    &__addAnotherRecipient{
      display: inline-flex;
      color: $bb-90;
      cursor: pointer;
      &__label{
        margin-left: 10px;
      }
      svg{
        height: 25px;
        width: 25px;
      }
    }
  }
  .recipientLast{
    border-bottom: unset;
  }
  .form-label{
    font-size: 12px;
    color: $fi;
  }

  .personal-section{
    margin-bottom: 8px;
    border: 1px solid #e9e9e9;
    border-radius: 4px;
    &__header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px;
      cursor: pointer;
      outline: none;
      &__icon{
        margin-right: 24px;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
      }
      &__label{
        flex-grow: 1;
        margin-right: 16px;
        font-size: 18px;
        color: $fd;
        @media only screen and (max-width: $max-width-small) {
          font-size: 12px;
        }
      }
    }
    &__body{
      padding: 20px 20px 40px 20px;
      button{
        margin-right: 15px;
        margin-bottom: 10px;
      }
    }
  }
</style>
<script setup>
</script>